// 收藏符号——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `icon/collect/index${i + 1}`,
  name: `icon/collectIndex${i + 1}`,
  component: () => import(`@/views/recognize/icon/collect/index${i + 1}.vue`)
}))



export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 收藏符号——主流程，开始
    ...MainRoutes,
  ],
};
